import * as React from "react";

import clx from 'classnames'

type Props = {
    associated?: boolean
    className?: string
    children?: React.ReactNode
    label?: string
    indeterminate?: boolean,
    id?: string,
    name?: string,
    checked?: boolean,
    value?: boolean,
    setValue?: (value: boolean) => void,
    readOnly?: boolean,
}

export const RowText = ({ 
    associated, className, children, label, indeterminate, id, name, checked, value, setValue, readOnly
 }: Props) => {
    return (
        <div className={clx({
            'tw-py-2 tw-px-4': !associated,
            'tw-pl-8 tw-py-2 tw-pr-4': associated,
        }, className)}>
            <div className="tw-flex tw-items-center tw-gap-2">
                <span
                    className={clx("tw-text-base tw-text-content-base tw-text-left tw-flex-1", {
                        'tw-text-content-base': true,
                        // 'tw-text-neutral': textStyleType === 'secondary',
                    })}
                >
                    {label}
                </span>
            </div>
            {children}
        </div>
    )
}
